"use strict";
export var FiatCurrency = /* @__PURE__ */ ((FiatCurrency2) => {
  FiatCurrency2["AustralianDollar"] = "AUD";
  FiatCurrency2["BrazilianReal"] = "BRL";
  FiatCurrency2["CanadianDollar"] = "CAD";
  FiatCurrency2["ChineseYuan"] = "CNY";
  FiatCurrency2["Euro"] = "EUR";
  FiatCurrency2["BritishPound"] = "GBP";
  FiatCurrency2["HongKongDollar"] = "HKD";
  FiatCurrency2["IndonesianRupiah"] = "IDR";
  FiatCurrency2["IndianRupee"] = "INR";
  FiatCurrency2["JapaneseYen"] = "JPY";
  FiatCurrency2["NigerianNaira"] = "NGN";
  FiatCurrency2["PakistaniRupee"] = "PKR";
  FiatCurrency2["RussianRuble"] = "RUB";
  FiatCurrency2["SingaporeDollar"] = "SGD";
  FiatCurrency2["SouthKoreanWon"] = "KRW";
  FiatCurrency2["ThaiBaht"] = "THB";
  FiatCurrency2["TurkishLira"] = "TRY";
  FiatCurrency2["UkrainianHryvnia"] = "UAH";
  FiatCurrency2["UnitedStatesDollar"] = "USD";
  FiatCurrency2["VietnameseDong"] = "VND";
  return FiatCurrency2;
})(FiatCurrency || {});
export const DEFAULT_LOCAL_CURRENCY = "USD" /* UnitedStatesDollar */;
export const ORDERED_CURRENCIES = [
  "USD" /* UnitedStatesDollar */,
  "AUD" /* AustralianDollar */,
  "BRL" /* BrazilianReal */,
  "CAD" /* CanadianDollar */,
  "CNY" /* ChineseYuan */,
  "EUR" /* Euro */,
  "GBP" /* BritishPound */,
  "HKD" /* HongKongDollar */,
  "IDR" /* IndonesianRupiah */,
  "INR" /* IndianRupee */,
  "JPY" /* JapaneseYen */,
  "KRW" /* SouthKoreanWon */,
  "NGN" /* NigerianNaira */,
  "PKR" /* PakistaniRupee */,
  "RUB" /* RussianRuble */,
  "SGD" /* SingaporeDollar */,
  "THB" /* ThaiBaht */,
  "TRY" /* TurkishLira */,
  "UAH" /* UkrainianHryvnia */,
  "VND" /* VietnameseDong */
];
